import axiosInstance from "./AxiosInstance"

// Update the getLeads function to properly send the request
export function getAssignedPatient() {
  return axiosInstance.post("/servicecaller/assignedPatient", {  })
}

export function getTodayFollowUpsReminder() {
  return axiosInstance.post("/servicecaller/todaysFollowupReminder", {}) // ✅ Today's endpoint
}

export function getUpcomingFollowUpsReminder() {
  return axiosInstance.post("/servicecaller/upcomingFollowupReminder", {}) // ✅ Upcoming endpoint
}

 export function getServiceCallerAppointments(params = {}) {
  // params can include filters like date, status, etc.
  return axiosInstance.post("/servicecaller/appointments", params);
}

// 🚨 Emergency Patients List
export const getEmergencyPatients = () =>
  axiosInstance.post("/servicecaller/emergencyPatients", {});

// 🚨 Mark Emergency
export const markEmergencyPatient = (data) =>
  axiosInstance.post("/servicecaller/mark_emergency", data);

// ⚠️ Dropped Patients
export const getDroppedPatients = () =>
  axiosInstance.post("/servicecaller/dropPatients", {});
export function updatePanchkarmaTakenService(payload) {
  return axiosInstance.post("/servicecaller/punchkarmaTaken", payload);
}

export function getFollowup71221Days() {
  return axiosInstance.post(
    "/servicecaller/followupList71221Days",
    {}
  );
}

export function getAssignedLeads() {
  return axiosInstance.post("/servicecaller/assignedLeads", {});
}

export const getMedicineNotTakenService = () => {
  return axiosInstance.post("servicecaller/MedicineNotTaken");
};


export const getRoutedPatients = () => 
  axiosInstance.post("servicecaller/routedPatients");
